import { Trans } from "@lingui/react/macro"
import { Alert, Text } from "@mantine/core"
import { IconLock } from "@tabler/icons-react"

/**
 * Read-only affordance for settings panels: shown to a plain member in place of a
 * save button, explaining that changing the setting needs an owner/admin. Mirrors
 * the lock notice the Model-selection panel already uses. Purely presentational.
 */
export function SettingsReadOnlyNotice(): React.JSX.Element {
  return (
    <Alert variant="light" color="warning" icon={<IconLock size={16} />}>
      <Text size="sm">
        <Trans>You can view these settings, but only an owner or admin can change them.</Trans>
      </Text>
    </Alert>
  )
}
